import { render, staticRenderFns } from "./ssxx.vue?vue&type=template&id=6ad33dcd&scoped=true"
import script from "./ssxx.vue?vue&type=script&lang=js"
export * from "./ssxx.vue?vue&type=script&lang=js"
import style0 from "./ssxx.vue?vue&type=style&index=0&id=6ad33dcd&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad33dcd",
  null
  
)

export default component.exports